import Vue from "vue"
import VueRouter from "vue-router"
import Head from "@/components/header.vue"
import $store from "@/store/index.js"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "main",
    components: {
      header: Head,
      default: () => import("../views/content.vue"),
    },
  },{
    path: '/preview',
    name:'preview',
    components: {
      header: Head,
      default: () => import("../views/preview.vue"),
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  await $store.dispatch("getInitConfig")
  $store.dispatch('getLoginInfo')
  next()
})
export default router;
